import localeCacher from './locale';
export { getLangMsg, getCompLangMsg } from './locale';
export default localeCacher;